<template>
    <div>
        <section class="search_wrap">
            <div class="container"> 
                <div class="row">
                    <div class="col-md-3"></div>
                    <div class="col-md-6">
                        <h2>No Results Found</h2>
                        <p>Sorry, nothing matched your search. Please try again.</p>
                        <div class="search_input">
                            <form action="/" method="get" role="search" id="" class="" autocomplete="off">
                                <input type="search" name="q" value="" placeholder="Search">
                                <span class="search_icon"><i class="fas fa-search"></i></span>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-3"></div>
                </div>



                <h2>Search Results</h2>           
                <div class="row">
                    <div class="col-md-4 mb-30">
                        <div class="search_box">
                            <div class="thumb">
                                <a href="#">
                                    <img src="images/news_img1.png">
                                </a>
                            </div> 
                            <div class="content">
                                <span>
                                    <i class="fas fa-calendar-alt"></i> 2021-10-06
                                </span>
                                <h3>
                                    <a href="#">
                                        News Title
                                    </a>
                                </h3> 
                                <div class="read_more">
                                    <a href="#">
                                        Read More
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-30">
                        <div class="search_box">
                            <div class="thumb">
                                <a href="#">
                                    <img src="images/news_img1.png">
                                </a>
                            </div> 
                            <div class="content">
                                <span>
                                    <i class="fas fa-calendar-alt"></i> 2021-10-06
                                </span>
                                <h3>
                                    <a href="#">
                                        News Title
                                    </a>
                                </h3> 
                                <div class="read_more">
                                    <a href="#">
                                        Read More
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-30">
                        <div class="search_box">
                            <div class="thumb">
                                <a href="#">
                                    <img src="images/course-img1.png">
                                </a>
                            </div> 
                            <div class="content">
                                <span>
                                    <i class="fas fa-calendar-alt"></i> Jan 2021- Sep 2022
                                </span> 
                                <h3><a href="#">Computer Management</a></h3> 
                                <div class="price">$225.00</div> 
                                <div class="common_btn">
                                    <a href="#">View Course</a>
                                </div>
                            </div>
                        </div>
                    </div>
                     <div class="col-md-4 mb-30">
                        <div class="search_box">
                            <div class="thumb">
                                <a href="#">
                                    <img src="images/course-img1.png">
                                </a>
                            </div> 
                            <div class="content">
                                <span>
                                    <i class="fas fa-calendar-alt"></i> Jan 2021- Sep 2022
                                </span> 
                                <h3><a href="#">Computer Management</a></h3> 
                                <div class="price">$225.00</div> 
                                <div class="common_btn">
                                    <a href="#">View Course</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 mb-30">
                        <div class="search_box">
                            <div class="thumb">
                                <a href="#">
                                    <img src="images/course-img1.png">
                                </a>
                            </div> 
                            <div class="content">
                                <span>
                                    <i class="fas fa-calendar-alt"></i> Jan 2021- Sep 2022
                                </span> 
                                <h3><a href="#">Computer Management</a></h3> 
                                <div class="price">$225.00</div> 
                                <div class="common_btn">
                                    <a href="#">View Course</a>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </section>
    </div>
</template>


<script>

    export default {

        data() {
            this.get_search_contents()
            return {
                auth: this.$store.state.auth.isLoggedIn,
                user: this.$store.state.auth.current_user,
                current_locale:this.$i18n_global.locale,
                search_val:this.$route.query.q
            }
        },
        methods:{
            async get_search_contents(){
                var _self = this;
                var search_val = this.$route.query.q
                console.log(search_val);
                await this.$axios_global.post(_self.$hostname+'/api/search',{
                    search_val:search_val
                })
                .then((res) => {
                    var response = res.data.data;
                    _self.listing = response;
                })
                .catch((error) => {
                    return false;  
                }) 
                return false; 
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Search.vue